import { render, staticRenderFns } from "./SessionWarningModal.vue?vue&type=template&id=16335da7&scoped=true&"
import script from "./SessionWarningModal.vue?vue&type=script&lang=js&"
export * from "./SessionWarningModal.vue?vue&type=script&lang=js&"
import style0 from "./SessionWarningModal.vue?vue&type=style&index=0&id=16335da7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16335da7",
  null
  
)

export default component.exports